// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rowTransaction-module_transactionRow__rP1KA {
    display: flex;
    justify-content: flex-start;
    flex-grow: 1;
    overflow: hidden;
    margin-bottom: 4px;

    &:last-child {
        margin-bottom: 0;
    }
}

.rowTransaction-module_transactionRow__rP1KA.rowTransaction-module_alignRight__NpThw {
    justify-content: flex-end;
}

.rowTransaction-module_transactionRight__POJpE {
    margin-left: 8px;
    white-space: nowrap;
}

.rowTransaction-module_commonRowTransaction__HCNWL {
    font: var(--typography-main);
    border: none;
    width: 100%;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    outline: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    vertical-align: top;
    cursor: pointer;
    pointer-events: auto;
    border-radius: 0;
    padding: 16px 24px;
    min-height: 72px;
    text-align: left;
    color: var(--black);
    background: var(--white);

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: var(--grey_16_lc);
        }
    }
}

.rowTransaction-module_commonRowTransaction__HCNWL.rowTransaction-module_disabled__M7sCK {
    cursor: default;
    pointer-events: none;
}

.rowTransaction-module_transactionContent__gfC5X {
    width: 100%;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/Row/styles/rowTransaction.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;;IAElB;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;;IAExB;QACI;YACI,6BAA6B;QACjC;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB","sourcesContent":[".transactionRow {\n    display: flex;\n    justify-content: flex-start;\n    flex-grow: 1;\n    overflow: hidden;\n    margin-bottom: 4px;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n\n.transactionRow.alignRight {\n    justify-content: flex-end;\n}\n\n.transactionRight {\n    margin-left: 8px;\n    white-space: nowrap;\n}\n\n.commonRowTransaction {\n    font: var(--typography-main);\n    border: none;\n    width: 100%;\n    box-sizing: border-box;\n    display: inline-flex;\n    align-items: center;\n    outline: none;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    position: relative;\n    vertical-align: top;\n    cursor: pointer;\n    pointer-events: auto;\n    border-radius: 0;\n    padding: 16px 24px;\n    min-height: 72px;\n    text-align: left;\n    color: var(--black);\n    background: var(--white);\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: var(--grey_16_lc);\n        }\n    }\n}\n\n.commonRowTransaction.disabled {\n    cursor: default;\n    pointer-events: none;\n}\n\n.transactionContent {\n    width: 100%;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transactionRow": `rowTransaction-module_transactionRow__rP1KA`,
	"alignRight": `rowTransaction-module_alignRight__NpThw`,
	"transactionRight": `rowTransaction-module_transactionRight__POJpE`,
	"commonRowTransaction": `rowTransaction-module_commonRowTransaction__HCNWL`,
	"disabled": `rowTransaction-module_disabled__M7sCK`,
	"transactionContent": `rowTransaction-module_transactionContent__gfC5X`
};
export default ___CSS_LOADER_EXPORT___;
